import type { Work } from "@/types/work";

export const works: Work[] = [
  {
    id: "w1",
    title: "夜航之港",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "悬疑"],
    rating: 9.1,
    views: 128000,
    updatedAt: "2026-10-14",
    director: "陈默",
    cast: ["林知远", "苏晴", "段清和"],
    synopsis:
      "浓雾笼罩的海港小城，一桩尘封十二年的失踪案因一具浮尸重新翻开。摆渡人老周守着渡口，也守着唯一没人问起的那段往事。当年轻的记者追着线索而来，小城每个人都在说谎，而真相漂浮在夜航的航线上。",
    tagline: "所有线索，都指向那个沉默多年的摆渡人。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20film%20poster%20artwork%20of%20a%20lone%20figure%20on%20a%20foggy%20night%20harbor%20pier%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20dramatic%20moody%20lighting%2C%20film%20grain%20texture%2C%20minimalist%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=480&height=680&seq=w1-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20night%20harbor%20scene%20with%20dense%20fog%2C%20a%20lone%20ferry%20pier%20under%20amber%20lamp%20light%2C%20moody%20deep%20navy%20and%20warm%20orange%20tones%2C%20film%20grain%20texture%2C%20atmospheric%20artistic%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20cinematography&width=1600&height=900&seq=w1-backdrop&orientation=landscape",
    duration: "128分钟",
    status: "已完结",
  },
  {
    id: "w2",
    title: "长夜将明",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["犯罪", "悬疑"],
    rating: 8.7,
    views: 96500,
    updatedAt: "2026-10-15",
    director: "高弋",
    cast: ["陆则明", "温语彤", "沈砚"],
    synopsis:
      "一宗跨越三座城市的连环案件，让两位立场对立的调查者不得不同桌。一个相信证据，一个相信直觉；当长夜被拉得越来越长，他们才发现真正的对手，站在所有人信任的地方。",
    tagline: "天快亮了，可有些人再也没等到黎明。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20film%20poster%20artwork%20of%20a%20silhouette%20against%20a%20breaking%20dawn%20over%20a%20city%20skyline%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20tense%20dramatic%20mood%2C%20film%20grain%2C%20minimalist%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=480&height=680&seq=w2-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20empty%20city%20overpass%20at%20pre-dawn%20blue%20hour%20with%20warm%20streetlights%2C%20deep%20navy%20shadows%20and%20amber%20highlights%2C%20crime%20thriller%20atmosphere%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w2-backdrop&orientation=landscape",
    duration: "122分钟",
    status: "已完结",
  },
  {
    id: "w3",
    title: "山海谣",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["奇幻", "冒险"],
    rating: 8.9,
    views: 87200,
    updatedAt: "2026-10-09",
    director: "周砚青",
    cast: ["顾寒声", "江晚照", "宁怀"],
    synopsis:
      "少年阿谣循着一卷残破的古谣走入群山，那里沉睡着被世人遗忘的山与海。传说只要唱完这首谣，就能唤回逝去之人，代价是忘记自己是谁。他一路唱着，一路把自己的名字留在了风里。",
    tagline: "山海之间，藏着一个人的名字。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20fantasy%20film%20poster%20artwork%20of%20a%20young%20traveler%20facing%20misty%20layered%20mountains%2C%20golden%20amber%20sky%20with%20deep%20navy%20shadows%2C%20oriental%20mythical%20painterly%20style%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w3-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20stylized%20ancient%20mountain%20range%20under%20a%20dramatic%20sunset%20sky%2C%20misty%20layered%20peaks%2C%20golden%20amber%20light%20with%20deep%20navy%20shadows%2C%20mythical%20oriental%20atmosphere%2C%20film%20grain%2C%20artistic%20painterly%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w3-backdrop&orientation=landscape",
    duration: "136分钟",
    status: "已完结",
  },
  {
    id: "w4",
    title: "尘埃里的花",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.5,
    views: 64300,
    updatedAt: "2026-10-11",
    director: "何予安",
    cast: ["苏晴", "沈砚", "蒋南嘉"],
    synopsis:
      "母亲离世后，三个各自逃离多年的孩子被迫回到老屋整理遗物。一箱没寄出的信、一张改了又改的车票，让他们重新拼凑出一个从未真正了解过的她。原来最平常的爱，都开在没人看见的尘埃里。",
    tagline: "她把一生的花，都开在了没人看见的地方。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20film%20poster%20artwork%20of%20a%20small%20flower%20growing%20through%20cracked%20earth%20in%20warm%20afternoon%20light%2C%20deep%20navy%20shadows%20with%20amber%20tones%2C%20tender%20melancholic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w4-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20old%20countryside%20house%20interior%20with%20dust%20motes%20in%20warm%20sunlight%20through%20a%20window%2C%20deep%20navy%20shadows%20and%20amber%20highlights%2C%20quiet%20family%20drama%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=w4-backdrop&orientation=landscape",
    duration: "112分钟",
    status: "已完结",
  },
  {
    id: "w5",
    title: "归途列车",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情"],
    rating: 8.3,
    views: 52100,
    updatedAt: "2026-09-28",
    director: "李澈",
    cast: ["白亦然", "韩沐"],
    synopsis:
      "一趟春运夜行的绿皮火车上，两个素不相识的旅人因为一张被弄错的车票坐到一起。十五个小时、七个停靠站，他们把各自人生里最难说出口的部分，讲给了一个再也不会见面的人。",
    tagline: "有些人，只陪你看完一程夜路。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20film%20poster%20artwork%20of%20a%20lone%20lit%20train%20window%20at%20night%20with%20passing%20lights%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20nostalgic%20quiet%20mood%2C%20film%20grain%2C%20minimalist%20composition%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w5-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20night%20train%20rushing%20through%20a%20dark%20landscape%20with%20warm%20window%20lights%2C%20deep%20navy%20sky%20and%20amber%20glow%2C%20nostalgic%20road%20drama%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w5-backdrop&orientation=landscape",
    duration: "118分钟",
    status: "已完结",
  },
  {
    id: "w6",
    title: "逆光而行",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    rating: 8.6,
    views: 104800,
    updatedAt: "2026-10-13",
    director: "郑南舟",
    cast: ["罗子骁", "蒋南嘉"],
    synopsis:
      "退隐多年的拆弹专家被迫重返一线。四十八小时、三枚未拆的装置，还有一段他以为早已埋进尘土的关系。当城市在雨夜里屏住呼吸，他要在最后一秒决定，先救谁。",
    tagline: "有些东西，一旦拆开就再也回不去了。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20action%20film%20poster%20artwork%20of%20a%20lone%20figure%20walking%20through%20neon%20rain%2C%20deep%20navy%20shadows%20with%20warm%20orange%20neon%20glow%2C%20high%20contrast%20thriller%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w6-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=stylized%20neon-lit%20hong%20kong%20street%20at%20night%20seen%20from%20above%2C%20rain%20reflections%20on%20asphalt%2C%20deep%20navy%20shadows%20with%20warm%20orange%20neon%20glow%2C%20action%20thriller%20cinematic%20mood%2C%20film%20grain%2C%20dramatic%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=w6-backdrop&orientation=landscape",
    duration: "134分钟",
    status: "已完结",
  },
  {
    id: "w7",
    title: "雨中告别",
    type: "movie",
    year: 2020,
    region: "韩国",
    genres: ["爱情", "剧情"],
    rating: 8.2,
    views: 45800,
    updatedAt: "2026-09-20",
    director: "田未",
    cast: ["唐映雪", "程亦航"],
    synopsis:
      "分手那天，他们约定好要等一场雨。可首尔的雨季迟到了整整一个月，两个人便用这三十天，重新走了一遍从相遇到告别的每一条路。有些人不是不爱了，只是学会了怎么好好地再见。",
    tagline: "等一场雨，把话说完。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20romance%20film%20poster%20artwork%20of%20two%20distant%20figures%20under%20a%20shared%20umbrella%20in%20soft%20rain%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20tender%20melancholic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w7-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20rainy%20seoul%20street%20at%20dusk%20with%20wet%20reflections%20and%20warm%20shop%20lights%2C%20deep%20navy%20and%20amber%20palette%2C%20tender%20romance%20drama%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=w7-backdrop&orientation=landscape",
    duration: "109分钟",
    status: "已完结",
  },
  {
    id: "w8",
    title: "雾都疑影",
    type: "movie",
    year: 2023,
    region: "英国",
    genres: ["悬疑", "惊悚"],
    rating: 8.4,
    views: 39700,
    updatedAt: "2026-10-06",
    director: "吴斯年",
    cast: ["谢知微", "段清和"],
    synopsis:
      "1930 年代的雾都，一位调查员受雇寻人，却在一座接连下雨的庄园里发现，所有住户的证词都精确得不合常理。雾气散去之前，他必须先分辨，谁在说谎，以及自己是否也是被安排的一环。",
    tagline: "当所有人都说真话，那一定是出了错。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20mystery%20film%20poster%20artwork%20of%20a%20misty%20victorian%20manor%20silhouette%20at%20dusk%2C%20deep%20navy%20and%20cool%20amber%20tones%2C%20eerie%20suspenseful%20mood%2C%20film%20grain%2C%20minimalist%20composition%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w8-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20foggy%20victorian%20london%20street%20with%20gas%20lamps%20and%20a%20distant%20manor%2C%20deep%20navy%20shadows%20with%20faint%20amber%20glow%2C%20eerie%20mystery%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w8-backdrop&orientation=landscape",
    duration: "121分钟",
    status: "已完结",
  },
  {
    id: "w9",
    title: "城中之城",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "犯罪"],
    rating: 8.8,
    views: 143200,
    updatedAt: "2026-10-15",
    director: "秦白",
    cast: ["林知远", "江晚照", "韩沐"],
    synopsis:
      "一座不断向天空生长的城市，底下压着无数被写进规划图又划掉的名字。年轻的项目经理在利益与人情之间步步为营，直到他发现，自己也是这座城市正在施工的一部分。",
    tagline: "楼越盖越高，人却越来越低。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20tv%20drama%20poster%20artwork%20of%20towering%20modern%20skyscrapers%20under%20a%20dramatic%20overcast%20sky%2C%20deep%20navy%20and%20amber%20grading%2C%20urban%20tension%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w9-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20modern%20metropolis%20skyline%20at%20dusk%20with%20warm%20window%20lights%2C%20deep%20navy%20sky%20and%20amber%20glow%2C%20ambitious%20urban%20drama%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w9-backdrop&orientation=landscape",
    episodes: 30,
    status: "全30集",
  },
  {
    id: "w10",
    title: "落雪听禅",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "历史"],
    rating: 9.0,
    views: 156700,
    updatedAt: "2026-10-16",
    director: "周砚青",
    cast: ["陆则明", "温语彤", "罗子骁"],
    synopsis:
      "一场大雪掩埋了旧朝的恩怨，也掩埋了一封足以颠覆朝堂的密信。守陵的僧人、入宫的旧臣、还有那个从未被记录在族谱里的孩子，各自带着半截真相，在雪落无声的夜里走向同一座庙。",
    tagline: "雪落无声，人心有痕。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20historical%20tv%20poster%20artwork%20of%20a%20snow-covered%20ancient%20temple%20with%20warm%20lantern%20glow%2C%20deep%20navy%20and%20amber%20tones%2C%20elegant%20oriental%20style%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w10-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=stylized%20ancient%20chinese%20palace%20courtyard%20covered%20in%20falling%20snow%20at%20blue%20hour%2C%20red%20lanterns%20glowing%20warmly%2C%20deep%20navy%20and%20amber%20tones%2C%20elegant%20oriental%20painterly%20style%2C%20film%20grain%2C%20cinematic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w10-backdrop&orientation=landscape",
    episodes: 40,
    status: "更新至34集",
  },
  {
    id: "w11",
    title: "十二楼的月亮",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    rating: 8.4,
    views: 92100,
    updatedAt: "2026-10-14",
    director: "何予安",
    cast: ["苏晴", "顾寒声"],
    synopsis:
      "同一栋公寓楼的十二层，住着一个总是深夜归家的人和一个习惯早起的人。他们隔着一条走廊分享着同一轮月亮，直到某天，一封塞错门缝的信，把两条平行的时间线轻轻拉到了一起。",
    tagline: "我们隔着一条走廊，看同一轮月亮。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20romance%20drama%20poster%20artwork%20of%20an%20apartment%20window%20with%20a%20glowing%20moon%2C%20deep%20navy%20night%20with%20warm%20amber%20interior%20light%2C%20intimate%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w11-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20city%20apartment%20balcony%20at%20night%20with%20warm%20lights%20and%20a%20large%20moon%2C%20deep%20navy%20and%20amber%20palette%2C%20intimate%20urban%20romance%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w11-backdrop&orientation=landscape",
    episodes: 24,
    status: "更新至18集",
  },
  {
    id: "w12",
    title: "暗涌",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.9,
    views: 118900,
    updatedAt: "2026-10-12",
    director: "邵川",
    cast: ["沈砚", "谢知微", "段清和"],
    synopsis:
      "平静的江面下，暗涌从未停止。一桩看似意外的案件牵出二十年前的旧账，当年的知情者如今各自沉默。年轻的检察官沿着唯一没被烧掉的账本，一层层揭开那段被所有人默契遗忘的水下往事。",
    tagline: "水面平静，底下全是账。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20crime%20drama%20poster%20artwork%20of%20dark%20churning%20water%20with%20faint%20reflections%2C%20deep%20navy%20and%20cold%20amber%20tones%2C%20tense%20mysterious%20mood%2C%20film%20grain%2C%20minimalist%20composition%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w12-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20dark%20river%20at%20night%20with%20faint%20boat%20lights%20and%20mist%2C%20deep%20navy%20and%20cool%20amber%20palette%2C%20crime%20mystery%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w12-backdrop&orientation=landscape",
    episodes: 28,
    status: "全28集",
  },
  {
    id: "w13",
    title: "潮汐之下",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["科幻", "悬疑"],
    rating: 9.2,
    views: 134500,
    updatedAt: "2026-10-16",
    director: "吴斯年",
    cast: ["程亦航", "唐映雪"],
    synopsis:
      "当海水在深夜逆流，一座沿海实验站的七名成员发现，他们记录的时间正在悄悄缩短。没人离开过这座站，可每天都少了一个人的名字。潮汐之下，究竟藏着数据，还是藏着他们自己。",
    tagline: "海水开始倒流，时间开始少人。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20sci-fi%20tv%20poster%20artwork%20of%20a%20surreal%20backward-flowing%20wave%20under%20a%20glowing%20sky%2C%20teal%20and%20deep%20navy%20with%20orange%20accents%2C%20mysterious%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w13-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=futuristic%20stylized%20coastal%20research%20station%20at%20dusk%20with%20glowing%20horizon%2C%20surreal%20ocean%20waves%20flowing%20backwards%2C%20teal%20and%20deep%20navy%20palette%20with%20orange%20highlights%2C%20cinematic%20science%20fiction%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=w13-backdrop&orientation=landscape",
    episodes: 10,
    status: "全10集",
  },
  {
    id: "w14",
    title: "长安旧梦",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["古装", "历史"],
    rating: 8.7,
    views: 102300,
    updatedAt: "2026-09-30",
    director: "秦白",
    cast: ["罗子骁", "江晚照"],
    synopsis:
      "盛世长安的最后一夜，城门的守将做了一个谁都不能理解的决定。有人骂他叛徒，有人赞他英雄，而只有城楼那盏没被吹灭的灯知道，他守的从来不是城，是一个人临走时的一句话。",
    tagline: "他守的从来不是这座城。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20historical%20poster%20artwork%20of%20ancient%20chinese%20city%20gate%20at%20night%20with%20lanterns%2C%20deep%20navy%20and%20amber%20tones%2C%20grand%20oriental%20style%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w14-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20ancient%20chinese%20city%20at%20dusk%20with%20eaves%20and%20warm%20lantern%20lights%2C%20deep%20navy%20sky%20and%20amber%20glow%2C%20epic%20historical%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w14-backdrop&orientation=landscape",
    episodes: 46,
    status: "全46集",
  },
  {
    id: "w15",
    title: "少年游",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "剧情"],
    rating: 8.1,
    views: 71400,
    updatedAt: "2026-10-05",
    director: "李澈",
    cast: ["白亦然", "韩沐"],
    synopsis:
      "高三那年夏天，五个约定要一起去看海的人，最后只有一个真的出发了。十年后他们重新聚在那条老街，才发现当年没走成的那段路，其实一直都在他们各自的心里延伸着。",
    tagline: "那年没走成的那段路，一直都在。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20youth%20drama%20poster%20artwork%20of%20teenagers%20cycling%20down%20a%20sunlit%20old%20street%2C%20warm%20amber%20light%20with%20deep%20navy%20shadows%2C%20nostalgic%20bittersweet%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w15-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20sunny%20old%20town%20street%20with%20tall%20trees%20and%20warm%20light%20streaks%2C%20amber%20tones%20with%20deep%20navy%20shadows%2C%20nostalgic%20coming%20of%20age%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w15-backdrop&orientation=landscape",
    episodes: 20,
    status: "全20集",
  },
  {
    id: "w16",
    title: "群山回响",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "历史"],
    rating: 8.9,
    views: 88600,
    updatedAt: "2026-09-25",
    director: "田未",
    cast: ["段清和", "蒋南嘉"],
    synopsis:
      "山里的公路修通那年，老邮差把最后一袋信背上山。四十年来他替别人传递了无数句思念，自己却从没寄出过一封。当群山第一次听见汽车的声音，有些告别也第一次有了回响。",
    tagline: "他替所有人传信，却从未寄出过一封。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20period%20drama%20poster%20artwork%20of%20a%20lone%20postman%20on%20a%20mountain%20trail%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20earnest%20melancholic%20mood%2C%20film%20grain%2C%20minimalist%20composition%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w16-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20misty%20mountain%20village%20at%20dawn%20with%20a%20winding%20trail%20and%20warm%20window%20lights%2C%20deep%20navy%20and%20amber%20palette%2C%20earnest%20period%20drama%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w16-backdrop&orientation=landscape",
    episodes: 36,
    status: "全36集",
  },
  {
    id: "w17",
    title: "深海回声",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["科幻", "剧情"],
    rating: 8.5,
    views: 57800,
    updatedAt: "2026-10-02",
    director: "高弋",
    cast: ["韩沐", "唐映雪", "宁怀"],
    synopsis:
      "深海探测器在七千米处捕捉到一段无法解释的声波，听起来像一个人在说话。研究团队花了三年时间把它翻译出来，得到的却是一句只有特定的人才能听懂的话。",
    tagline: "深海传来的，不只是回声。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20sci-fi%20poster%20artwork%20of%20a%20deep%20sea%20submersible%20with%20a%20glowing%20light%20in%20dark%20water%2C%20deep%20navy%20and%20teal%20with%20amber%20accents%2C%20mysterious%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w17-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20deep%20ocean%20abyss%20with%20a%20glowing%20submersible%20beam%20and%20floating%20particles%2C%20deep%20navy%20and%20teal%20with%20amber%20accents%2C%20mysterious%20sci-fi%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w17-backdrop&orientation=landscape",
    duration: "125分钟",
    status: "已完结",
  },
  {
    id: "w18",
    title: "风起时",
    type: "movie",
    year: 2023,
    region: "日本",
    genres: ["爱情"],
    rating: 8.0,
    views: 41200,
    updatedAt: "2026-09-18",
    director: "田未",
    cast: ["谢知微", "苏晴"],
    synopsis:
      "海边小城的风每年只吹一次，吹过的那天人们会说真话。两个各自藏着一件事的女人，在风起的那一天相遇，又在风停之后成为了彼此最长时间的沉默。",
    tagline: "风起的那天，人们只说真话。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20romance%20poster%20artwork%20of%20a%20woman%20with%20hair%20blown%20by%20wind%20on%20a%20seaside%20cliff%2C%20deep%20navy%20sky%20and%20warm%20amber%20light%2C%20gentle%20melancholic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w18-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20seaside%20coastal%20town%20with%20tall%20grass%20swaying%20in%20wind%20under%20a%20pastel%20sky%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20gentle%20art%20house%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w18-backdrop&orientation=landscape",
    duration: "106分钟",
    status: "已完结",
  },
  {
    id: "w19",
    title: "无名之辈",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "犯罪"],
    rating: 8.6,
    views: 68300,
    updatedAt: "2026-09-22",
    director: "郑南舟",
    cast: ["段清和", "白亦然"],
    synopsis:
      "小城里一桩没人在意的抢劫案，把一群本该毫无交集的普通人卷了进来。修车工、跑腿的外卖员、守着棋摊的老人，他们都没有名字被记住，却在那一个星期里，活成了自己人生里的主角。",
    tagline: "没有名字的人，也在认真地活着。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20dark%20comedy%20poster%20artwork%20of%20ordinary%20figures%20in%20a%20narrow%20alley%20at%20dusk%2C%20deep%20navy%20and%20muted%20amber%20tones%2C%20poignant%20mood%2C%20film%20grain%2C%20minimalist%20composition%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w19-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20small%20town%20alley%20at%20dusk%20with%20warm%20lamp%20lights%20and%20hanging%20laundry%2C%20deep%20navy%20and%20muted%20amber%20palette%2C%20poignant%20drama%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w19-backdrop&orientation=landscape",
    duration: "116分钟",
    status: "已完结",
  },
  {
    id: "w20",
    title: "江湖再见",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["武侠", "动作"],
    rating: 8.3,
    views: 75900,
    updatedAt: "2026-10-10",
    director: "邵川",
    cast: ["罗子骁", "顾寒声"],
    synopsis:
      "退隐的剑客答应妻子此生不再动剑，直到那把他以为早已断掉的旧剑重新出现在镇上。有些江湖不是想退就能退的，有些人再见，其实是为了好好地告别。",
    tagline: "退得掉的是江湖，退不掉的是人。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20wuxia%20poster%20artwork%20of%20a%20lone%20swordsman%20silhouette%20on%20a%20misty%20ridge%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20heroic%20melancholic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w20-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20misty%20mountain%20ridge%20at%20dawn%20with%20a%20lone%20figure%20and%20bamboo%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20wuxia%20atmosphere%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w20-backdrop&orientation=landscape",
    duration: "130分钟",
    status: "已完结",
  },
  {
    id: "w21",
    title: "迷雾档案",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.8,
    views: 97600,
    updatedAt: "2026-10-16",
    director: "邵川",
    cast: ["林知远", "谢知微"],
    synopsis:
      "档案室的最后一排，锁着二十宗从未被公开的旧案。新任资料管理员在整理时发现，每一份卷宗缺失的那一页，笔迹都出自同一个人——而那个人，上个月刚刚退休。",
    tagline: "被抽走的那一页，一直有人在写。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20crime%20series%20poster%20artwork%20of%20stacks%20of%20old%20case%20files%20under%20a%20single%20lamp%2C%20deep%20navy%20and%20amber%20tones%2C%20suspenseful%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w21-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20dim%20archive%20room%20with%20tall%20shelves%20of%20files%20and%20a%20warm%20desk%20lamp%2C%20deep%20navy%20shadows%20and%20amber%20glow%2C%20crime%20mystery%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w21-backdrop&orientation=landscape",
    episodes: 26,
    status: "更新至20集",
  },
  {
    id: "w22",
    title: "花开半夏",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["爱情", "家庭"],
    rating: 8.2,
    views: 63900,
    updatedAt: "2026-10-07",
    director: "何予安",
    cast: ["温语彤", "沈砚", "蒋南嘉"],
    synopsis:
      "一家开了三十年的老花店要在半夏时节关门，三代人在这间小店里的爱恨与遗憾，都要在最后一个月里被重新摆上台面。花会谢，但有些话终于赶在了关门前说出口。",
    tagline: "花会谢，话要趁早说。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20family%20drama%20poster%20artwork%20of%20a%20small%20flower%20shop%20in%20summer%20light%2C%20deep%20navy%20shadows%20and%20warm%20amber%20tones%2C%20tender%20nostalgic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w22-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20cozy%20old%20flower%20shop%20interior%20with%20warm%20sunlight%20and%20abundant%20blooms%2C%20amber%20tones%20with%20deep%20navy%20shadows%2C%20tender%20family%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w22-backdrop&orientation=landscape",
    episodes: 32,
    status: "全32集",
  },
  {
    id: "w23",
    title: "极地航线",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["冒险", "灾难"],
    rating: 8.4,
    views: 62100,
    updatedAt: "2026-10-04",
    director: "高弋",
    cast: ["蒋南嘉", "程亦航"],
    synopsis:
      "一架飞往北极科考站的运输机在暴风雪中失联，唯一的幸存者必须在天亮之前穿过冰原找到救援。零下四十度的夜里，比寒冷更致命的，是那个谁都不愿承认的决定。",
    tagline: "天亮之前，必须有人做出选择。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20survival%20poster%20artwork%20of%20a%20lone%20figure%20crossing%20a%20frozen%20polar%20wasteland%2C%20deep%20navy%20blue%20with%20warm%20amber%20horizon%2C%20desolate%20dramatic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w23-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20polar%20ice%20field%20under%20a%20dramatic%20stormy%20sky%20with%20distant%20warm%20light%2C%20deep%20navy%20blue%20and%20amber%20palette%2C%20survival%20disaster%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w23-backdrop&orientation=landscape",
    duration: "138分钟",
    status: "已完结",
  },
  {
    id: "w24",
    title: "星轨旅人",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.7,
    views: 81300,
    updatedAt: "2026-10-15",
    director: "吴斯年",
    cast: ["唐映雪", "宁怀"],
    synopsis:
      "一艘沿着星轨航行的补给船，载着十二个没有归途的旅人。每到一颗星球，就有人下船，也有人说要留下。船长从不问为什么，因为在这条航线上，每一个离开的人都曾认真地想过要不要留下。",
    tagline: "沿着星轨，每个人都曾是旅人。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20sci-fi%20series%20poster%20artwork%20of%20a%20cargo%20spaceship%20against%20a%20starfield%20with%20a%20glowing%20trail%2C%20deep%20navy%20space%20with%20warm%20orange%20engine%20glow%2C%20wondrous%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=480&height=680&seq=w24-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20spaceship%20cruising%20past%20a%20ringed%20planet%20with%20a%20glowing%20star%20trail%2C%20deep%20navy%20space%20with%20warm%20orange%20accents%2C%20awe-inspiring%20sci-fi%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w24-backdrop&orientation=landscape",
    episodes: 12,
    status: "全12集",
  },
];